import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import classes from "../customer.module.css";
import FilterButton from "../../../../Components/Filters/FilterButton";
import FilterDrawer from "../../../../Components/Filters/FilterDrawer";
import CheckboxFilterGroup from "../../../../Components/Filters/CheckboxFilterGroup";
import StatusFilter from "../../../../Components/Filters/StatusFilter";
import {
  OppositeSortArrawBtnIcons,
  SortArrawBtnIcons,
} from "../../../../Components/Icons/Icons";
import {
  durationFilter,
  planNameFilter,
  teamNameFilter,
  InvoiceFilterAction,
} from "../../../../Redux/actions/filterActions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchCustomerSubscriptions } from "../../../../Redux/actions/customerActions";
import SubscriptionListItem from "./SubscriptionListItem";
import AddSubscriptionModal from "./AddSubscriptionModal";
import { handleSortClick } from "../../../../Utilities/commonfunctions";
import { Button } from "@mui/material";

const Subscription = (props) => {
  const dispatch = useDispatch();
  const { sortBy } = useSelector((state) => state.filter);
  const [teamsList, setTeamsList] = useState();
  const [durationList, setDurationList] = useState();
  const [planNamesList, setPlanNames] = useState();
  const { planNames, durations, teamNames, invoice } = useSelector(
    (state) => state.filter
  );

  const [addModalOpen, setAddModalOpen] = useState(false);

  const refetchSubscriptions = () => {
    const filters = {
      planNames,
      durations,
      teamNames,
      active: invoice,
    };
    dispatch(fetchCustomerSubscriptions(props?.id, sortBy, filters));
  };

  useEffect(() => {
    refetchSubscriptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortBy, planNames, durations, teamNames, dispatch, props?.id, invoice]);

  const subscriptionData = useSelector((state) => state.customerData);

  const { loading, error, subscriptions } = subscriptionData;
  useEffect(() => {
    if (subscriptions?.length > 0) {
      const array = subscriptions.map((subscription) => {
        return subscription?.team_info?.team_name;
      });
      const array1 = subscriptions.map((subscription) => {
        return subscription?.duration_details?.duration;
      });
      const array2 = subscriptions.map((subscription) => {
        return subscription?.subscription_info?.packageName;
      });
      const resultArray = array.filter((value, index, self) => {
        return (
          value !== undefined && value !== "" && self.indexOf(value) === index
        );
      });
      const resultArray1 = array1.filter((value, index, self) => {
        return (
          value !== undefined && value !== "" && self.indexOf(value) === index
        );
      });
      const resultArray2 = array2.filter((value, index, self) => {
        return (
          value !== undefined && value !== "" && self.indexOf(value) === index
        );
      });
      console.log(resultArray, resultArray1);
      setTeamsList(resultArray);
      setPlanNames(resultArray2);
      setDurationList(resultArray1);
    }
  }, [subscriptions]);

  const [filterOpen, setFilterOpen] = useState(false);
  const activeCount =
    (teamNames?.length || 0) +
    (planNames?.length || 0) +
    (durations?.length || 0) +
    (invoice?.length || 0);
  const handleClearAll = () => {
    dispatch(teamNameFilter([]));
    dispatch(planNameFilter([]));
    dispatch(durationFilter([]));
    dispatch(InvoiceFilterAction([]));
  };

  return (
    <div className={classes.tableContainer}>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginBottom: "8px" }}>
        <Button variant="contained" onClick={() => setAddModalOpen(true)}>
          Add Subscription
        </Button>
        <FilterButton
          activeCount={activeCount}
          onClick={() => setFilterOpen(true)}
        />
      </div>
      <Table className={classes.MainTable}>
        <TableHead>
          <TableRow className={classes.tableHeadRow}>
            <TableCell />
            <TableCell className={classes.tableHeadCell}>
              <div className={classes.tableHEadercelldiv}>
                <span> Team </span>{" "}
                <span
                  onClick={() =>
                    handleSortClick(dispatch, sortBy, "team_info.team_name")
                  }
                >
                  {sortBy?.includes("desc") &&
                  sortBy?.includes("team_info.team_name") ? (
                    <OppositeSortArrawBtnIcons />
                  ) : (
                    <SortArrawBtnIcons />
                  )}
                </span>
              </div>
            </TableCell>
            <TableCell className={classes.tableHeadCell}>
              <div className={classes.tableHEadercelldiv}>
                <span> Plan Name </span>{" "}
                <span
                  onClick={() =>
                    handleSortClick(
                      dispatch,
                      sortBy,
                      "subscription_info.packageName"
                    )
                  }
                >
                  {sortBy?.includes("desc") &&
                  sortBy?.includes("subscription_info.packageName") ? (
                    <OppositeSortArrawBtnIcons />
                  ) : (
                    <SortArrawBtnIcons />
                  )}
                </span>
              </div>
            </TableCell>
            <TableCell className={classes.tableHeadCell}>
              <div className={classes.tableHEadercelldiv}>
                <span> Duration </span>{" "}
                <span
                  onClick={() =>
                    handleSortClick(
                      dispatch,
                      sortBy,
                      "duration_details.duration"
                    )
                  }
                >
                  {sortBy?.includes("desc") &&
                  sortBy?.includes("duration_details.duration") ? (
                    <OppositeSortArrawBtnIcons />
                  ) : (
                    <SortArrawBtnIcons />
                  )}
                </span>
              </div>
            </TableCell>
            <TableCell
              className={classes.tableHeadCell}
              style={{ minWidth: 80 }}
            >
              Seats
            </TableCell>
            <TableCell
              className={classes.tableHeadCell}
              style={{ minWidth: 150 }}
            >
              Price
            </TableCell>
            <TableCell
              className={classes.tableHeadCell}
              style={{ minWidth: 200 }}
            >
              Plan Validity
            </TableCell>
            <TableCell className={classes.tableHeadCell}>
              <div className={classes.tableHEadercelldiv}>
                <span> Status </span>{" "}
                {/* <span
                  onClick={() => handleSortClick(dispatch, sortBy, "status")}
                >
                  {sortBy?.includes("desc") && sortBy?.includes("status") ? (
                    <OppositeSortArrawBtnIcons />
                  ) : (
                    <SortArrawBtnIcons />
                  )}
                </span> */}
              </div>
            </TableCell>
          </TableRow>
        </TableHead>
      </Table>
      <Table>
        <TableBody>
          {loading ? (
            <TableRow>
              <td colSpan="9" className="text-center">
                Loading...
              </td>
            </TableRow>
          ) : error ? (
            <TableRow>
              <td colSpan="9" className="text-center">
                {error}
              </td>
            </TableRow>
          ) : subscriptions && subscriptions.length > 0 ? (
            subscriptions.map((item, index) => (
              <SubscriptionListItem
                key={index}
                subscription={item}
                customerId={props?.id}
                sort={sortBy}
                filters={{
                  planNames,
                  durations,
                  teamNames,
                  active: invoice,
                }}
                onCancelled={refetchSubscriptions}
              />
            ))
          ) : (
            <TableRow>
              <td colSpan="9" className="text-center">
                No Data Found
              </td>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <FilterDrawer
        open={filterOpen}
        onClose={() => setFilterOpen(false)}
        onClearAll={handleClearAll}
      >
        <CheckboxFilterGroup
          label="Team"
          options={teamsList}
          selected={teamNames}
          action={teamNameFilter}
        />
        <CheckboxFilterGroup
          label="Plan Name"
          options={planNamesList}
          selected={planNames}
          action={planNameFilter}
        />
        <CheckboxFilterGroup
          label="Duration"
          options={durationList}
          selected={durations}
          action={durationFilter}
        />
        <StatusFilter label="Status" selected={invoice} />
      </FilterDrawer>
      {addModalOpen && (
        <AddSubscriptionModal
          customerId={props?.id}
          modalClose={setAddModalOpen}
          onAssigned={refetchSubscriptions}
        />
      )}
    </div>
  );
};

export default Subscription;
